import { injectable } from 'tsyringe';
import { OWSettings } from '../../odk-ts/ow-settings';
import { IOWSettingsWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-settings-wrapper.interface';

// -----------------------------------------------------------------------------
@injectable()
export class OWSettingsWrapper implements IOWSettingsWrapper {
  public async getLanguage() {
    return OWSettings.getLanguage();
  }
}
